export const timelineEntries = [
  {
    id: 0,
    timestamp: "1982",
    event: {
      "pt-br": "Nasci @ Fortaleza, Ceará, Brasil",
      "en-us": "Born @ Fortaleza, Ceará, Brazil"
    },
    type: "spawn"
  },
  {
    id: 1,
    timestamp: "1987 ~ 1998",
    event: {
      "pt-br": "Ensino fundamental no Colégio Santa Cecília",
      "en-us": "Went to school at Colégio Santa Cecília"
    },
    type: "school"
  },
  {
    id: 2,
    timestamp: "1999 ~ 2000",
    event: {
      "pt-br": "Ensino médio no Colégio 7 de Setembro",
      "en-us": "Went to high school at Colégio 7 de Setembro"
    },
    type: "school"
  },
  {
    id: 3,
    timestamp: "2001",
    event: {
      "pt-br": "Pré-Vestibular no Colégio Lourenço Filho",
      "en-us": "Senior Year of High School at Colégio Lourenço Filho"
    },
    type: "graduation"
  },
  {
    id: 4,
    timestamp: "2001",
    event: {
      "pt-br":
        "Aprovado nos vestibulares da UFC (Univ. Federal do Ceará) @ Engenharia Elétrica &amp; UECE (Univ. Estadual do Ceará) @ Ciências da Computação (5º lugar)",
      "en-us":
        "Approved in the entrance exam to UFC (Federal University of Ceará) @ Electrical Engineering &amp; UECE (Ceará State University) @ Computer Science (5th place)"
    },
    type: "achievement"
  },
  {
    id: 5,
    timestamp: "2002",
    event: {
      "pt-br": "Ingresso na UECE - Ciências da Computação",
      "en-us": "Admission to UECE - Computer Science"
    },
    type: "university"
  },
  {
    id: 6,
    timestamp: "2004 @ SEINFRA-PMJP",
    event: {
      "pt-br":
        "Estágio remunerado (6 meses) na Prefeitura Municipal de Fortaleza (SEINFRA - Secretária de Infra-Estrutura). Trabalhei com desenvolvimento de software (ASP/SQL/VBSCRIPT).",
      "en-us":
        "Paid internship (6 months) at Fortaleza City Hall (SEINFRA - Secretary for Infrastructure). Worked with software development (ASP / SQL / VBSCRIPT)."
    },
    type: "work"
  },
  {
    id: 7,
    timestamp: "2005",
    event: {
      "pt-br": "Mudança para João Pessoa, Paraíba, Brasil",
      "en-us": "Relocates to João Pessoa, Paraíba, Brazil"
    },
    type: "relocate"
  },
  {
    id: 8,
    timestamp: "2005",
    event: {
      "pt-br": "Cursei durante 1 ano o pré-vestibular no Motiva",
      "en-us":
        "I attended the Motiva preparatory course for UFPB (Federal University of Paraíba) entrance exam for 1 year"
    },
    type: "school"
  },
  {
    id: 9,
    timestamp: "2005",
    event: {
      "pt-br":
        "Aprovado no vestibular da UFPB (Universidade Federal da Paraíba) - Ciências da Computação (2º lugar)",
      "en-us":
        "Approved in the entrance exam at UFPB - Computer Science (2nd place)"
    },
    type: "achievement"
  },
  {
    id: 10,
    timestamp: "2006",
    event: {
      "pt-br": "Ingresso na UFPB - Ciências da Computação (é... denovo)",
      "en-us": "Admission to UFPB - Computer Science (yeap... again)"
    },
    type: "university"
  },
  {
    id: 11,
    timestamp: "2005~2009 @ SETDE-PB",
    event: {
      "pt-br":
        "Reiniciei minha carreira, agora em João Pessoa, no Governo do Estado da Paraíba - Secretaria de Turismo e Des. Econômico - Programa de Artesanato da Paraíba “A Paraíba em suas mãos”. Iniciei como estagiário, seis meses depois fui 'efetivado' (cargo comissionado) para o setor de processamento de dados do programa.",
      "en-us":
        "Restarted my career, now in João Pessoa, in the Paraíba State Government - Secretariat of Tourism and Economic Development - Paraíba Craft Program “A Paraíba em suas mãos (Paraíba in your hands)”. I started as an intern, six months later I was 'hired' (commissioned position) for the program's data processing sector."
    },
    type: "work"
  },
  {
    id: 12,
    timestamp: "2009~2017 @ Integrativa / BeHOH",
    event: {
      "pt-br":
        "Ingressei como estagiário de meio-período na Integrativa Soluções Tecnológicas (também 6 meses), sendo efetivado logo em seguida. Trabalhei como desenvolvedor, passando para analista de sistemas júnior, analista de sistemas pleno, e deixei o cargo como líder técnico. Durante esses 8 anos atuei em diversos papéis relacionados ao desenvolvimento de sistemas, em especial Java e desenvolvimento WEB, contribuindo em aproximadamente 60 projetos de diferentes tamanhos, clientes e fins.",
      "en-us":
        "Joined as a part-time intern at Integrativa Soluções Tecnológicas (also 6 months), being hired shortly thereafter. Worked as a developer, moving to junior systems analyst, systems analyst, and left the position as technical leader. Java and WEB development. During these 8 years I worked in different roles related to systems development, mostly Java and WEB technologies, contributing to approximately 60 projects of different sizes, clients and purposes."
    },
    type: "work"
  },
  {
    id: 13,
    timestamp: "2012 @ UFPB",
    event: {
      "pt-br": "Graduado bacharel em Ciências da Computação",
      "en-us": "Bachelor's degree in Computer Science"
    },
    type: "graduation"
  },
  {
    id: 14,
    timestamp: "2017 @ Unimed JP",
    event: {
      "pt-br":
        "Ingressei na UNIMED João Pessoa como analista de sistemas pleno",
      "en-us": "Joined UNIMED João Pessoa as a systems analyst"
    },
    type: "work"
  },
  {
    id: 15,
    timestamp: "2019 @ Unimed JP",
    event: {
      "pt-br": "Efetivado analista de sistemas sênior em dezembro de 2019",
      "en-us": "Became a senior systems analyst in december 2019"
    },
    type: "work"
  }
].reverse();
